import { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';
import Tooltip from '@components/common/Tooltip';

const SizeMixedChart = () => {
    const chartRef = useRef<HTMLDivElement>(null);
    const chartInstance = useRef<ApexCharts | null>(null);

    useEffect(() => {
        if (!chartRef.current) return;

        const options = {
            series: [
                {
                    type: 'area',
                    name: '유지호흡',
                    data: [
                        445, 270, 353, 398, 710, 727, 423, 330, 657, 496, 312,
                        634, 601, 401,
                    ],
                },
                {
                    type: 'line',
                    name: '생장호흡',
                    data: [
                        137, 103, 112, 62, 281, 253, 190, 24, 240, 38, 291, 182,
                        139, 50,
                    ],
                },
            ],
            chart: {
                type: 'line',
                height: 273,
                toolbar: {
                    show: false,
                },
                dropShadow: {
                    enabled: true,
                    enabledOnSeries: undefined,
                    top: 7,
                    left: 0,
                    blur: 1,
                    //color: ['rgb(227, 84, 212)',"var(--primary-color)"],
                    opacity: 0.05,
                },
            },
            grid: {
                borderColor: '#f1f1f1',
                strokeDashArray: 3,
            },
            //colors: ["rgb(227, 84, 212)", "var(--primary-color)"],
            fill: {
                type: ['gradient', 'soild'],
                gradient: {
                    opacityFrom: 0.23,
                    opacityTo: 0.23,
                    shadeIntensity: 0.3,
                },
            },
            plotOptions: {
                bar: {
                    columnWidth: '20%',
                    borderRadius: 2,
                },
            },
            stroke: {
                width: [1.5, 2],
                curve: ['smooth', 'smooth'],
                dashArray: [5, 0],
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                show: true,
                position: 'top',
            },
            yaxis: {
                Show: true,
                labels: {
                    show: true,
                },
            },
            xaxis: {
                show: false,
                type: 'day',
                categories: [
                    '2025-08-01',
                    '2025-08-02',
                    '2025-08-03',
                    '2025-08-04',
                    '2025-08-05',
                    '2025-08-06',
                    '2025-08-07',
                    '2025-08-08',
                    '2025-08-09',
                    '2025-08-10',
                    '2025-08-11',
                    '2025-08-12',
                    '2025-08-13',
                    '2025-08-14',
                ],
                labels: {
                    formatter: function (value, timestamp) {
                        const date = new Date(value);
                        const year = String(date.getFullYear()).slice(-2); // 'yy' 형식의 년도
                        const month = ('0' + (date.getMonth() + 1)).slice(-2); // 'MM' 형식의 월
                        const day = ('0' + date.getDate()).slice(-2); // 'dd' 형식의 일
                        return `${year}.${month}.${day}`;
                    },
                },
                axisBorder: {
                    show: false,
                    color: 'rgba(119, 119, 142, 0.05)',
                    offsetX: 0,
                    offsetY: 0,
                },
            },
        };

        chartInstance.current = new ApexCharts(chartRef.current, options);
        chartInstance.current.render();

        return () => {
            if (chartInstance.current) {
                chartInstance.current.destroy();
            }
        };
    }, []);

    return (
        <div className="custom-card card">
            <div className="card-header justify-content-between align-items-center d-sm-flex d-block">
                <div className="card-title mb-sm-0 mb-2">
                    유지,생장 호흡
                    <Tooltip
                        content="도움말이 표시될예정"
                        customClass="tooltip-dark"
                        placement="top"
                    >
                        <i className="ri-question-line" />
                    </Tooltip>
                </div>
                <div
                    aria-label="Basic example"
                    role="group"
                    className="flex-wrap btn-group"
                >
                    <button type="button" className="btn-wave btn btn-success">
                        14일
                    </button>
                    <button
                        type="button"
                        className="btn-wave btn btn-success-light"
                    >
                        한달
                    </button>
                    <button
                        type="button"
                        className="btn-wave btn btn-success-light"
                    >
                        6개월
                    </button>
                    <button
                        type="button"
                        className="btn-wave btn btn-success-light"
                    >
                        1년
                    </button>
                    <button
                        type="button"
                        className="btn-wave btn btn-success-light"
                    >
                        더보기
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div ref={chartRef} style={{}}></div>
            </div>
        </div>
    );
};

export default SizeMixedChart;
